import { NoticeTypes } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { AssetSelectedTypeMap } from '../../../../../../../../../store/product/types';

import { DirectTreasuryItemSelectedDesktop } from './desktop';
import { DirectTreasuryItemSelectedMobile } from './mobile';
import { DirectTreasuryItemSelectedTablet } from './tablet';

export namespace DirectTreasuryItemSelectedTypes {
  export interface Props {
    offer: AssetSelectedTypeMap['directTreasurySell'];
    onUpdate: (offerUpdated: AssetSelectedTypeMap['directTreasurySell']) => void;
    hideLateralBar?: boolean;
  }
}

export const directTreasuryRescueNoticeMessage = [
  { text: 'Atenção: ', variant: 'bold' },
  {
    text: 'O Resgate solicitado após as 13h só é concluído no próximo dia útil. Lembrando: o valor pode sofrer alterações.',
    variant: 'regular',
  },
] as NoticeTypes.TextObject[];

export const DirectTreasuryItemSellSelected: React.FC<DirectTreasuryItemSelectedTypes.Props> = (
  props
) => {
  const directTreasurySelectedItem = useBreakpointValue({
    base: <DirectTreasuryItemSelectedMobile {...props} />,
    sm: <DirectTreasuryItemSelectedTablet {...props} />,
    lg: <DirectTreasuryItemSelectedDesktop {...props} />,
  });

  return directTreasurySelectedItem;
};
